import { useCallback } from 'react'

import { useAxiosAsync } from '@/@bothrs-react/hooks/useAxiosAsync'
import { useIntegrationAxios } from '@/modules/healthblocks/hooks/useIntegrationAxios'

import type { CacheAxiosResponse } from 'axios-cache-interceptor'
import type { Kinship, SynopsContactRelationType } from '../types/kinship.types'

export function useKinshipTypes() {
  const axios = useIntegrationAxios()

  const getKinshipTypes = useCallback(() => {
    return axios
      .get<SynopsContactRelationType[]>('/synops/patient-contact-relation-types', {
        cache: {
          ttl: 0,
        },
      })
      .then((value) => {
        return (
          value?.data
            ? {
                ...value,
                data: value.data.map(
                  (kinship) =>
                    ({
                      id: kinship.oazisId,
                      value: kinship.oazisId,
                      label: kinship.value,
                    }) as Kinship,
                ),
              }
            : value
        ) as CacheAxiosResponse<Kinship[]>
      })
  }, [axios])

  return {
    getKinshipTypes: useAxiosAsync(getKinshipTypes),
  }
}
